
import TitleService from 'title-service';
import './EpisodeSelectorHeader.scss';
import SeasonDropDown from './SeasonDropDown';
export default function EpisodeSelectorHeader(props: any) {
    return (
        <div className="episodeSelector-header ">
            <h3 className="previewModal--section-header episodeSelector-label">{TitleService(`Épisodes`)}</h3>
            <div className="episodeSelector-dropdown">
            </div>
            <div className="episodeSelector-season-name season-drop-down">
                {props.season > 1 && <SeasonDropDown seasons={props.seasons}
                    selectedIndex={props.selectedSeasonIndex}
                    setSelected={(index) => {
                        if (props.onSetSeasonIndex) {
                            props.onSetSeasonIndex(index)
                        }
                    }} />}
                {props.season < 2 && TitleService(`Season`)}&nbsp;{props.season < 2 && props.season || ''}</div>
        </div>
    );
}